var render, staticRenderFns
import script from "./VTextField.vue?vue&type=script&lang=ts"
export * from "./VTextField.vue?vue&type=script&lang=ts"
import style0 from "./VTextField.vue?vue&type=style&index=0&id=238702e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238702e7",
  null
  
)

export default component.exports